module.exports = __webpack_public_path__ + "assets/low-screen_icon.200e9d81.svg";